import request from "@/utils/request";

export function exchangeList(data) {
  return request({
    url: "/ustn/convertList",
    method: "get",
    params: data
  });
}

export function signDatatoHex(data) {
  return request({
    url: "/crosschain/signDatatoHex",
    method: "post",
    data: data
  });
}

export function getPubKey(data) {
  return request({
    url: "/crosschain/getPubKey",
    method: "post",
    data: data
  });
}
export function getSignData(data) {
  return request({
    url: "/crosschain/getSignData",
    method: "post",
    data: data
  });
}
export function boardcastTrans(data) {
  return request({
    url: "/crosschain/boardcastTrans",
    method: "post",
    data: data
  });
}
export function abi(data) {
  return request({
    url: "/contracts/abi",
    method: "get",
    params: data,
    headers: { rejectUnauthorized: false }
  });
}
export function changeAddress(data) {
  return request({
    url: "/crosschain/changeAddress",
    method: "post",
    data: data,
    headers: { rejectUnauthorized: false }
  });
}
// "/api/crosschain/changeAddress";
